import React from 'react'
import './style.css'
import delorian from './Delorean.webp'
import useRoutes from 'hooks/useRoutes'
import { HOME_PATH } from 'routes/constants.routes'

const NoMatch = () => {
  const { push } = useRoutes()

  return (
    <div className="notFoundContainer">
      <section className="notFound">
        <div className="img">
          <img src={delorian} alt="El Delorean, El Doc y Marti McFly" />
        </div>
        <div className="text">
          <h1>404</h1>
          <h2>Страница не найдена!</h2>
          <h3>Вернуться домой?</h3>
          <a onClick={() => push(HOME_PATH)} className="yes">
            ДА
          </a>
        </div>
      </section>
    </div>
  )
}
export default NoMatch
